import React, { useState } from 'react';
import { Box, Text, Button } from 'grommet';
import CustomerSearch from '../../CustomerSearch';
import BaseFilter from '../../filters/BaseFilter';
import { formatName } from '../../../utils/names';

const SearchCustomerFilter = ({ selectedItems = [], onApplyFilter, customerGroupId }) => {
    const [localItems, setLocalItems] = useState(selectedItems);

    const handleSelect = (items) => {
        setLocalItems(items);
    };

    const renderContent = () => {
        return (
            <Box width="300px">
                <CustomerSearch
                    initialSelectedCustomers={localItems}
                    onSelect={handleSelect}
                    customerGroupId={customerGroupId}
                    multiple={true}
                    includeGroups={!customerGroupId}
                    minHeight="200px"
                    compact={true}
                />
                <Box margin={{ top: 'small' }}>
                    <Button fill type="submit" primary label="Apply" />
                </Box>
            </Box>
        );
    };

    const getDisplayName = (item) => {
        if (!item) return null;
        const name = item.company_name || formatName(item, true) || `#${item.id}`;
        return item._type === 'group' ? `${name} (Group)` : name;
    };

    const renderButtonLabel = () => {
        if (!selectedItems || selectedItems.length === 0) return null;
        if (selectedItems.length === 1) {
            const name = getDisplayName(selectedItems[0]);
            // Truncate long names
            return name && name.length > 12 ? `${name.substring(0, 12)}...` : name;
        }
        return `${selectedItems.length} selected`;
    };

    const onApply = () => {
        onApplyFilter(localItems);
    };

    const onReset = () => {
        setLocalItems([]);
        onApplyFilter([]);
    };

    return (
        <BaseFilter
            filterName="Customer"
            renderContent={renderContent}
            renderButtonLabel={renderButtonLabel}
            isActive={selectedItems && selectedItems.length > 0}
            onReset={onReset}
            onApply={onApply}
        />
    );
};

export default SearchCustomerFilter;
